<!--
	作者：masonchen
	时间：2017-04-07
	描述：报警计划中心页面
-->
<template>
	<div class="wrapper wrapper-content animated fadeInRight tabBox" id="alarmplan-home">
        <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
          <div class="row ">
            <div class="col-sm-12  pauto20px">
              <div class="module_title02 pb0px"> <span>行驶区域报警</span> </div>
              <div class="row alarm_list">
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_areaAlarmHome') == -1" :cellData="alarmData[0][0]" :imageData="alarm_icon.icon_11"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_areaAlarmOut') == -1" :cellData="alarmData[0][1]" :imageData="alarm_icon.icon_12"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_areaAlarmRange') == -1" :cellData="alarmData[0][2]" :imageData="alarm_icon.icon_13"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_areaAlarmStraight') == -1" :cellData="alarmData[0][3]" :imageData="alarm_icon.icon_14"></alarm-cell>
              </div>
            </div>
            <div class="col-sm-12  pauto20px pt0px">
              <div class="module_title02 pb0px"> <span>车辆状态报警</span> </div>
              <div class="row alarm_list">
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_statusAlarmFire') == -1" :cellData="alarmData[1][0]" :imageData="alarm_icon.icon_21"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_statusAlarmOnline') == -1" :cellData="alarmData[1][1]" :imageData="alarm_icon.icon_22"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_statusAlarmOffline') == -1" :cellData="alarmData[1][2]" :imageData="alarm_icon.icon_23"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_statusAlarmOver') == -1" :cellData="alarmData[1][3]" :imageData="alarm_icon.icon_24"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_statusAlarmStop') == -1" :cellData="alarmData[1][4]" :imageData="alarm_icon.icon_25"></alarm-cell>
              </div>
            </div>
            <div class="col-sm-12  pauto20px pt0px">
              <div class="module_title02 pb0px"> <span>设备失效报警</span> </div>
              <div class="row alarm_list">
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_effectAlarmFake') == -1" :cellData="alarmData[2][0]" :imageData="alarm_icon.icon_31"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_effectAlarmDis') == -1" :cellData="alarmData[2][1]" :imageData="alarm_icon.icon_32"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_effectAlarmPulldown') == -1" :cellData="alarmData[2][2]" :imageData="alarm_icon.icon_33"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_effectAlarmPosition') == -1" :cellData="alarmData[2][3]" :imageData="alarm_icon.icon_34"></alarm-cell>
              </div>
            </div>
            <div class="col-sm-12  pauto20px pt0px">
              <div class="module_title02 pb0px"> <span>驾驶行为报警</span> </div>
              <div class="row alarm_list">
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_driveAlarmTired') == -1" :cellData="alarmData[3][0]" :imageData="alarm_icon.icon_41"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_driveAlarmInterval') == -1" :cellData="alarmData[3][1]" :imageData="alarm_icon.icon_42"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_driveAlarmOver') == -1" :cellData="alarmData[3][2]" :imageData="alarm_icon.icon_43"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_driveAlarmLimit') == -1" :cellData="alarmData[3][3]" :imageData="alarm_icon.icon_44"></alarm-cell>
              </div>
            </div>
            <div class="col-sm-12  pauto20px pt0px">
              <div class="module_title02 pb0px"> <span>车辆故障报警</span> </div>
              <div class="row alarm_list">
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_faultAlarmPowerLow') == -1" :cellData="alarmData[4][0]" :imageData="alarm_icon.icon_51"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_faultAlarmNum') == -1" :cellData="alarmData[4][1]" :imageData="alarm_icon.icon_52"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_faultAlarmOilLow') == -1" :cellData="alarmData[4][2]" :imageData="alarm_icon.icon_53"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_faultAlarmOilTime') == -1" :cellData="alarmData[4][3]" :imageData="alarm_icon.icon_54"></alarm-cell>
              	<alarm-cell v-if="permission.indexOf('alarmPlanHome_faultAlarmOilEvery') == -1" :cellData="alarmData[4][4]" :imageData="alarm_icon.icon_55"></alarm-cell>
              </div>
            </div>
          </div>
        </div>
        
        <!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
</div>
</template>

<script>
	import {alarm_icon} from 'static/constant'
	import { OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import AlarmCell from 'components/pages/alarmplan/PageAlarmCell'
	import {PAGE_NO} from 'static/constant'
	import classlist from 'util/classlist'
	
	export default{
		name: 'PageAlarmPlanHome',
		components: {
			AlarmCell,
			TabModal
		},
		data(){
			return{
				permission:this.$store.state.permission.permission["alarmPlanHome"]?this.$store.state.permission.permission["alarmPlanHome"]:[],
				loadingstatus:false,
				alarm_icon: alarm_icon,
				alarmData: [[
				{
					alarmType: "1",
					alarmPageName: "areaAlarmHome",
					alarmTypeName: PAGE_NO["1"].alarmTypeName,
					title: PAGE_NO["1"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["1"].message,
					bgcolor: PAGE_NO["1"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "2",
					alarmPageName: "areaAlarmOut",
					alarmTypeName: PAGE_NO["2"].alarmTypeName,
					title: PAGE_NO["2"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["2"].message,
					bgcolor:  PAGE_NO["2"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "3",
					alarmPageName: "areaAlarmRange",
					alarmTypeName: PAGE_NO["3"].alarmTypeName,
					title: PAGE_NO["3"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["3"].message,
					bgcolor:  PAGE_NO["3"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "4",
					alarmPageName: "areaAlarmStraight",
					alarmTypeName: PAGE_NO["4"].alarmTypeName,
					title: PAGE_NO["4"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["4"].message,
					bgcolor:  PAGE_NO["4"].bgcolor,
					isEnable:"0"
				}],[
				{
					alarmType: "5",
					alarmPageName: "statusAlarmFire",
					alarmTypeName: PAGE_NO["5"].alarmTypeName,
					title: PAGE_NO["5"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["5"].message,
					bgcolor:  PAGE_NO["5"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "6",
					alarmPageName: "statusAlarmOnline",
					alarmTypeName: PAGE_NO["6"].alarmTypeName,
					title: PAGE_NO["6"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["6"].message,
					bgcolor:  PAGE_NO["6"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "8",
					alarmPageName: "statusAlarmOffline",
					alarmTypeName: PAGE_NO["8"].alarmTypeName,
					title: PAGE_NO["8"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["8"].message,
					bgcolor:  PAGE_NO["8"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "7",
					alarmPageName: "statusAlarmOver",
					alarmTypeName: PAGE_NO["7"].alarmTypeName,
					title: PAGE_NO["7"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["7"].message,
					bgcolor:  PAGE_NO["7"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "19",
					alarmPageName: "statusAlarmStop",
					alarmTypeName: PAGE_NO["19"].alarmTypeName,
					title: PAGE_NO["19"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["19"].message,
					bgcolor:  PAGE_NO["19"].bgcolor,
					isEnable:"1"
				}],[
				{
					alarmType: "21",
					alarmPageName: "effectAlarmFake",
					alarmTypeName: PAGE_NO["21"].alarmTypeName,
					title: PAGE_NO["21"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["21"].message,
					bgcolor:  PAGE_NO["21"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "20",
					alarmPageName: "effectAlarmDis",
					alarmTypeName: PAGE_NO["20"].alarmTypeName,
					title: PAGE_NO["20"].alarmTypeName+"报警",
					count: 0,
					message:PAGE_NO["20"].message,
					bgcolor:  PAGE_NO["20"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "9",
					alarmPageName: "effectAlarmPulldown",
					alarmTypeName: PAGE_NO["9"].alarmTypeName,
					title: PAGE_NO["9"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["9"].message,
					bgcolor:  PAGE_NO["9"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "22",
					alarmPageName: "effectAlarmPosition",
					alarmTypeName: PAGE_NO["22"].alarmTypeName,
					title: PAGE_NO["22"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["22"].message,
					bgcolor:  PAGE_NO["22"].bgcolor,
					isEnable:"1"
				}],[
				{
					alarmType: "10",
					alarmPageName: "driveAlarmTired",
					alarmTypeName: PAGE_NO["10"].alarmTypeName,
					title: PAGE_NO["10"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["10"].message,
					bgcolor:  PAGE_NO["10"].bgcolor,
					isEnable:"0"
				},{
					alarmType: "11",
					alarmPageName: "driveAlarmInterval",
					alarmTypeName: PAGE_NO["11"].alarmTypeName,
					title: PAGE_NO["11"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["11"].message,
					bgcolor:  PAGE_NO["11"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "12",
					alarmPageName: "driveAlarmOver",
					alarmTypeName: PAGE_NO["12"].alarmTypeName,
					title: PAGE_NO["12"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["12"].message,
					bgcolor:  PAGE_NO["12"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "13",
					alarmPageName: "driveAlarmLimit",
					alarmTypeName: PAGE_NO["13"].alarmTypeName,
					title: PAGE_NO["13"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["13"].message,
					bgcolor:  PAGE_NO["13"].bgcolor,
					isEnable:"1"
				}],[
				{
					alarmType: "14",
					alarmPageName: "faultAlarmPowerLow",
					alarmTypeName: PAGE_NO["14"].alarmTypeName,
					title: PAGE_NO["14"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["14"].message,
					bgcolor:  PAGE_NO["14"].bgcolor,
					isEnable:"0"
				},{
					alarmType: "15",
					alarmPageName: "faultAlarmNum",
					alarmTypeName: PAGE_NO["15"].alarmTypeName,
					title: PAGE_NO["15"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["15"].message,
					bgcolor:  PAGE_NO["15"].bgcolor,
					isEnable:"1"
				},{
					alarmType: "16",
					alarmPageName: "faultAlarmOilLow",
					alarmTypeName: PAGE_NO["16"].alarmTypeName,
					title: PAGE_NO["16"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["16"].message,
					bgcolor:  PAGE_NO["16"].bgcolor,
					isEnable:"0"
				},{
					alarmType: "17",
					alarmPageName: "faultAlarmOilTime",
					alarmTypeName: PAGE_NO["17"].alarmTypeName,
					title: PAGE_NO["17"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["17"].message,
					bgcolor:  PAGE_NO["17"].bgcolor,
					isEnable:"0"
				},{
					alarmType: "18",
					alarmPageName: "faultAlarmOilEvery",
					alarmTypeName: PAGE_NO["18"].alarmTypeName,
					title: PAGE_NO["18"].alarmTypeName+"报警",
					count: 0,
					message: PAGE_NO["18"].message,
					bgcolor:  PAGE_NO["18"].bgcolor,
					isEnable:"0"
				}]],
				messageStr: "",					// 弹出框内容
				scrollTop: '0'
			}
		},
		// 组件初始化
		beforeMount(){
			this.getPlanCount();
		},
		methods:{
			getPlanCount(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/count', {params:{customerId:this.$store.state.user.groupid,planOwnerType:1}})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.setAlarmCount(resInfo);
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#alarmplan-home',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#alarmplan-home',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
        	setAlarmCount(alarmList){
        		let datalist = this.alarmData;
        		alarmList.forEach(function(e){  
        			switch(e.almType){    			
		    			case '1'://进入区域
		    				datalist[0][0].count=e.planCount;
		    				break;
		    			case '2'://驶出区域
		    				datalist[0][1].count=e.planCount;
		    				break;
		    			case '3'://原地驻防
		    				datalist[0][2].count=e.planCount;
		    				break;
		    			case '4'://路线偏移
		    				datalist[0][3].count=e.planCount;
		    				break;
		    			case '5'://车辆点火
		    				datalist[1][0].count=e.planCount;
		    				break;
		    			case '6'://车辆上线
		    				datalist[1][1].count=e.planCount;
		    				break;
		    			case '8'://离线超时
		    				datalist[1][2].count=e.planCount;
		    				break;
		    			case '7'://停车超时
		    				datalist[1][3].count=e.planCount;
		    				break;
		    			case '19'://停车异动
		    				datalist[1][4].count=e.planCount;
		    				break;
		    			case '21'://伪基站
		    				datalist[2][0].count=e.planCount;
		    				break;
		    			case '20'://有线无线距离
		    				datalist[2][1].count=e.planCount;
		    				break;
		    			case '9'://设备拆除
		    				datalist[2][2].count=e.planCount;
		    				break;
		    			case '22'://定位失效
		    				datalist[2][3].count=e.planCount;
		    				break;
		    			case '10'://疲劳驾驶
		    				datalist[3][0].count=e.planCount;
		    				break;
		    			case '11'://行车时段
		    				datalist[3][1].count=e.planCount;
		    				break;
		    			case '12'://车辆超速
		    				datalist[3][2].count=e.planCount;
		    				break;
		    			case '13'://行驶里程超限
		    				datalist[3][3].count=e.planCount;
		    				break;
		    			case '14'://电瓶低电压
		    				datalist[4][0].count=e.planCount;
		    				break;
		    			case '15'://车辆故障
		    				datalist[4][1].count=e.planCount;
		    				break;
		    			case '16'://油量低水平
		    				datalist[4][2].count=e.planCount;
		    				break;
		    			case '17'://瞬时油耗
		    				datalist[4][3].count=e.planCount;
		    				break;
		    			case '18'://日均油耗
		    				datalist[4][4].count=e.planCount;
		    				break;
        			}
				})  
        	}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageAlarmPlanHome.vue?012fd8f7